import React, { useEffect, useState } from 'react';
import {
  Card, Container, Row, Col,
  Form, Button, InputGroup, Pagination,Modal
} from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import Select from 'react-select';
import StatusToggle from './StatusToggle';
import './UserListPage.css'; // custom styles
import { getUser } from '../../../API/Service/shopService';
import useToast from '../../../API/GlobalHooks/useToast';
import { getImageUrl } from '../../../MIS/Global';


const statusOptions = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

const UserListPage = () => {
  const showToast = useToast();
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState(statusOptions[0]);  
  const [users, setUsers] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState({});
  const limit=25;  

  const handlePrev = () => {
    setPage((prev) => Math.max(prev - 1, 1));
    const newPage = Math.max(page - 1, 1); 
    let data={limit:limit,page:newPage,
      p_search:search.trim(),user_role:'user'}
    if(status?.value==="all"){      
      data=data;      
    }else if(status?.value==="active"){
      data={...data,user_status:1};      
    }else if(status?.value==="inactive"){
      data={...data,user_status:0};      
    }
    handleGetUsers(data)
  };

  const handleNext = () => {
    setPage((prev) => Math.min(prev + 1, totalPage));
    const newPage = Math.min(page + 1, totalPage);
    let data={limit:limit,page:newPage,p_search:search.trim(),user_role:'user'}
    if(status?.value==="all"){      
      data=data;      
    }else if(status?.value==="active"){
      data={...data,user_status:1};      
    }else if(status?.value==="inactive"){
      data={...data,user_status:0};      
    }
    handleGetUsers(data)  
  };  

  const handleUserStatus=(user_status)=>{
    if(parseInt(user_status,10)===0){
      return false;
    }
    return true;
  }
  const handleGetUsers= async (data)=>{
    setLoading(true);
    try {      
      const resData=await getUser(data);
      setUsers(resData?.data);
      setTotalPage(resData?.total_pages)
    } catch (error) {
      showToast("Something went wrong! Please try again", 'danger');
     }finally {
      setLoading(false); // Hide loader
    }

  }
  useEffect(() => {
    let data={limit:limit,page:1,p_search:search.trim(),user_role:'user'}
    if(status?.value==="all"){      
      data=data;      
    }else if(status?.value==="active"){
      data={...data,user_status:1};      
    }else if(status?.value==="inactive"){
      data={...data,user_status:0};      
    }
    handleGetUsers(data)
    setPage(1);
  },[status])

  const handleSearch = () => {
    let data={limit:limit,page:1,p_search:search.trim(),user_role:'user'}
    if(status?.value==="all"){      
      data=data;      
    }else if(status?.value==="active"){
      data={...data,user_status:1};      
    }else if(status?.value==="inactive"){
      data={...data,user_status:0};      
    }
    handleGetUsers(data)
    setPage(1);    
  };

  const handleShowDocs = (user) => {
    setSelectedDocs({
      businessCertificate: user.businessCertificate,
      gstCertificate: user.gstCertificate,
      adharCard: user.adharCard,
      utilityBill: user.utilityBill,
    });
    setShowModal(true);
  };
 
  return (
    <>
    <Container fluid className="p-3 user-list-wrapper">
      {/* Heading */}
      <h4 className="mb-3">User List</h4>

      {/* Filter + Pagination Row */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 gap-2">
        <div className="d-flex flex-column flex-md-row gap-2" style={{ flexGrow: 1 }}>
          <InputGroup size="sm" style={{ maxWidth: 400 }}>
            <InputGroup.Text><FaSearch /></InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search by keywords..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button variant="primary" onClick={handleSearch}>Search</Button>
          </InputGroup>

          <div style={{ minWidth: 180 }}>
            <Select
              options={statusOptions}
              value={status}
              onChange={setStatus}
              isSearchable={false}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '31px',
                  fontSize: '0.875rem',
                }),
              }}
            />
          </div>
        </div>

        {/* Pagination Top Right */}
        <Pagination size="sm" className="mb-0 mt-2 mt-md-0">
          <Pagination.Prev onClick={handlePrev} disabled={page === 1} />
          <Pagination.Item active>{`${page}/${totalPage}`}</Pagination.Item>
          <Pagination.Next onClick={handleNext} disabled={page === totalPage} />
        </Pagination>
      </div>

      {/* Scrollable User Cards */}
      <div className="user-card-scroll-container">
      {loading ? (
        <>
         <div className='d-flex justify-content-center align-items-center'>
          <span
            className="text-primary spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
            style={{ width: '2rem', height: '2rem' }}
          ></span>
          </div>
        </>
        ):(
          <>
        {users.length === 0 && !loading ? (
            <div className="text-center text-muted py-4">
              <h5>No records found</h5>
              <p>Please adjust your filters or try a different search.</p>
            </div>
          ) : (
          users.map((user) => (
          <Card key={user.id} className="mb-3 shadow-sm border-0 user-card">
            <Card.Body className="py-3 px-4">
              <Row className="gy-2 align-items-center">
                <Col xs={12} md={4}>
                  <div>
                    <div className="fw-semibold fs-6">{user.shopName}</div>
                    <div className="text-muted small d-flex flex-wrap gap-1">
                      <span>{user.shopType}</span>
                      <span>|</span>
                      <span>{user.state}</span>
                      <span>|</span>
                      <span>{user.city}</span>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div>
                    <div className="fw-semibold fs-6">{user.ownerName}</div>                    
                    <div className="text-muted small d-flex flex-wrap gap-1">
                      <span>{user.mob}</span>
                      <span>|</span>
                      <span>{user.emailid}</span>                       
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={4} className="d-flex justify-content-md-end gap-2">
                  <StatusToggle isActive={handleUserStatus(user?.user_status)} id={user?.id} />
                  {/* <Button variant="outline-secondary" size="sm">Docs</Button> */}
                  <Button variant="outline-secondary" size="sm" onClick={() => handleShowDocs(user)}>Docs</Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          )
        ))}
        </>
        )}
      </div>
    </Container>
    <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>User Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-4">
            {[
              { key: "businessCertificate", label: "Business Certificate" },
              { key: "gstCertificate", label: "GST Certificate" },
              { key: "adharCard", label: "Aadhar Card" },
              { key: "utilityBill", label: "Utility Bill" }
            ].map(({ key, label }) => (
              <Col md={6} key={key}>
                <Card className="h-100 shadow-sm">
                  <Card.Header className="fw-semibold">{label}</Card.Header>
                  <Card.Body className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                    {selectedDocs[key] ? (
                      <img
                        src={getImageUrl(`${selectedDocs[key]}`)}
                        alt={label}
                        className="img-fluid rounded border"
                        style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                      />
                    ) : (
                      <div className="text-muted text-center">No Document</div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserListPage;
